import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { currentUser } from '~/lib/pb';
import { useActiveTenantId, useTenantContext } from '~/lib/tenantContext';
import { useCreateBookingPage, type BookingPageInput } from '~/lib/booking-queries';
import { BookingPageForm } from '~/components/BookingPageForm/BookingPageForm';
import styles from './_authed.agenda.editor.module.css';

export const Route = createFileRoute('/_authed/agenda_/nueva')({
  component: NewBookingPage,
});

function NewBookingPage() {
  const me = currentUser();
  const tenantId = useActiveTenantId();
  const { selectedTenant } = useTenantContext();
  const isSuperadmin = me?.role === 'superadmin';
  const navigate = useNavigate();
  const create = useCreateBookingPage();

  if (!isSuperadmin) {
    return (
      <div className={styles.page}>
        <p className={styles.muted}>Las páginas de reserva las configura Life Focus.</p>
      </div>
    );
  }
  if (!tenantId) {
    return (
      <div className={styles.page}>
        <p className={styles.muted}>Selecciona un cliente en el topbar.</p>
      </div>
    );
  }

  async function handleSave(form: BookingPageInput) {
    const created = await create.mutateAsync(form);
    navigate({ to: '/agenda/$pageId', params: { pageId: created.id } });
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Link to="/agenda" className={styles.back}>
          <ArrowLeft size={16} aria-hidden /> Agenda
        </Link>
        <h1 className="h2">Nueva página de reserva</h1>
      </header>

      <BookingPageForm
        tenantId={tenantId}
        defaultTz={selectedTenant?.timezone || 'America/Santiago'}
        page={null}
        tenantSlug={selectedTenant?.slug || ''}
        saving={create.isPending}
        onSave={handleSave}
        onCancel={() => navigate({ to: '/agenda' })}
      />
    </div>
  );
}
